import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=e3ca8d12&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=e3ca8d12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ca8d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ca8d12')) {
      api.createRecord('e3ca8d12', component.options)
    } else {
      api.reload('e3ca8d12', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=e3ca8d12&scoped=true", function () {
      api.rerender('e3ca8d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/bankPaymentManagement/tabs.vue"
export default component.exports